module.exports = {
    "breadcrumbs": `Categorias`
};


//# sourceMappingURL=pt-PT.main.js.map
